import GoldenRockBetBarComponent from "goldenrock/components/betbar/golden-rock-bet-bar-component";

export default class SgBetBarComponent extends GoldenRockBetBarComponent {
    public addRemainingFreespins(numSpins:number):void{
        this.remainingFreespins += numSpins;
        this.updateTexts();
    }
}
